import { render } from "./EstadoInicialExcel.vue?vue&type=template&id=0ab22077&scoped=true"
const script = {}

import "./EstadoInicialExcel.vue?vue&type=style&index=0&id=0ab22077&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab22077"]])

export default __exports__